function isBooleanOrBooleanString(value) {
    return value instanceof Boolean || typeof value === 'boolean' || value === 'true' || value === 'false';
}

module.exports = function () {
    const args = Array.prototype.slice.call(arguments, 0, -1);
    const options = arguments[arguments.length - 1];

    args.forEach(arg => {
        const [varName, ...varValueParts] = arg.split(' ');
        let varValue = varValueParts.join(' ');

        // Convert string values to boolean if applicable
        if (isBooleanOrBooleanString(varValue)) {
            varValue = (varValue === 'true') ? true : (varValue === 'false') ? false : varValue;
        }

        if (!options.data.root) {
            options.data.root = {};
        }
        options.data.root[varName] = varValue;
    });

    return options.fn(this);
};


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/hbHelpers/let.js
// module id = 8
// module chunks = 0